import antd from 'antd';
import styled from 'styled-components';
import Col, { ColSize } from 'antd/lib/col';
const { Form } = antd;

export const StyleStrippingScheduleForm = styled(Form)`
  // max-width: 600px;
  // min-width: 300px;
`;

declare type ColSpanType = ColSize;

export const ScheduleColSize: { [key: string]: ColSpanType } = {
  lg: {
    span: 18,
    offset: 3,
  },
  sm: {
    span: 24,
  },
};

export const ScheduleCol = styled(Col)`

padding: 0px;
margin: 0px;
text-align: center;

.searchButton{
  // float: right
}

`;